var _defs, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-0{fill:none;}\n            .cls-1{fill:#fff;}\n            .cls-2{fill:#efeff0;}\n            .cls-3{fill:#d2ddfa;}\n            .cls-4{fill:#b4c6fa;}\n            .cls-5{fill:#4a77f6;}\n            .cls-6{fill:#668fff;}\n            .cls-7{fill-rule:evenodd;}\n            .cls-8{fill:#f1f1f3;}\n            .cls-9{fill:#80a2ff;}\n            .cls-10{fill:#1750eb;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm.08,19.25a1.49,1.49,0,1,1,1.49-1.48A1.5,1.5,0,0,1,12.08,19.25Zm2.68-6.91c-.84.64-1.57,1.18-1.57,2.44v.44H11l0-.2a6.29,6.29,0,0,1-.1-.91,4,4,0,0,1,1.95-3.18c.79-.63,1.47-1.18,1.47-2.13a1.74,1.74,0,0,0-1.93-1.65A2.4,2.4,0,0,0,10,8.86l-.07.27L7.71,8.29l0-.22a4.62,4.62,0,0,1,4.61-3.32c2.83,0,4.52,2,4.52,3.86A4.18,4.18,0,0,1,14.76,12.34Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.08,
    cy: 17.77,
    r: 1.48
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.37,4.75A4.62,4.62,0,0,0,7.76,8.07l0,.22,2.17.84L10,8.86a2.4,2.4,0,0,1,2.42-1.71A1.74,1.74,0,0,1,14.3,8.8c0,.95-.68,1.5-1.47,2.13a4,4,0,0,0-1.95,3.18A6.29,6.29,0,0,0,11,15l0,.2h2.17v-.44c0-1.26.73-1.8,1.57-2.44a4.18,4.18,0,0,0,2.13-3.73C16.89,6.71,15.2,4.75,12.37,4.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.db73ad1677a386c222947fde3a1d853b.svg";
export { ForwardRef as ReactComponent };